// features/spark/scripts/static-generate.ts 로 생성된 파일입니다.
// next.js 에서 이 파일을 복사해서 사용하면 됩니다.
import multiplydesktop960 from '@flipster/features/static/spark/reward/multiply_desktop_960_1x.webp';
import multiplydesktop1920 from '@flipster/features/static/spark/reward/multiply_desktop_960_2x.webp';
import multiply from '@flipster/features/static/spark/reward/multiply_mobile_360_1x.webp';
import multiplymobile360 from '@flipster/features/static/spark/reward/multiply_mobile_360_1x.webp';
import multiplymobile720 from '@flipster/features/static/spark/reward/multiply_mobile_360_2x.webp';
import multiplymobile420 from '@flipster/features/static/spark/reward/multiply_mobile_420_1x.webp';
import multiplymobile840 from '@flipster/features/static/spark/reward/multiply_mobile_420_2x.webp';
import multiplymobile768 from '@flipster/features/static/spark/reward/multiply_mobile_768_1x.webp';
import multiplymobile1536 from '@flipster/features/static/spark/reward/multiply_mobile_768_2x.webp';

export default {
  img: {
    src: multiply.src,
    width: 360,
    height: 439,
    alt: 'How to gain more sparks',
  },
  sources: [
    {
      media: '(max-width: 767px)',
      srcSet: [
        `${multiplymobile360.src} 360w`,
        `${multiplymobile720.src} 720w`,
        `${multiplymobile420.src} 420w`,
        `${multiplymobile840.src} 840w`,
        `${multiplymobile768.src} 768w`,
        `${multiplymobile1536.src} 1536w`,
      ].join(', '),
      sizes: '100vw',
    },
    {
      srcSet: [`${multiplydesktop960.src} 960w`, `${multiplydesktop1920.src} 1920w`].join(', '),
      sizes: '960px',
    },
  ],
};
